import WeatherWidget from '@/components/WeatherWidget'

const SELECTOR = '.component-weather-widget'

function staticData (root) {
  return window.grecos && window.grecos.data ? window.grecos.data[root.id] : {}
}

/* eslint-disable */
function getComponentData (root) {
  const { DailyData, YearlyData } = staticData(root).DynamicContent
  const { Id, Multiple_Value_Mode, Season_First_Month, Season_Last_Month } = staticData(root).StaticContent
  return {
    DailyData,
    YearlyData,
    configurationId: Id,
    mode: Multiple_Value_Mode,
    seasonFirstMonth: Season_First_Month,
    seasonLastMonth: Season_Last_Month,
  }
}
/* eslint-enable */

module.exports = {
  init () {
    document.querySelectorAll(SELECTOR).forEach(el => {
      if (!staticData(el).DynamicContent) return
      
      const data = getComponentData(el)
      new WeatherWidget({ el, propsData: { data } })
    })
  },
}



// WEBPACK FOOTER //
// ./src/modules/weather-widget.js